/**
 * Lightweight logging utility with environment-aware log levels.
 *
 * In production, only warnings and errors are output.
 * In development, all levels (debug, info, warn, error) are output.
 */

const LOG_LEVELS = { debug: 0, info: 1, warn: 2, error: 3 };

const isProduction = process.env.NODE_ENV === 'production';
const minLevel = isProduction ? LOG_LEVELS.warn : LOG_LEVELS.debug;

function shouldLog(level) {
  return LOG_LEVELS[level] >= minLevel;
}

const logger = {
  debug: (...args) => {
    if (shouldLog('debug')) console.debug('[DEBUG]', ...args); // eslint-disable-line no-console
  },
  info: (...args) => {
    if (shouldLog('info')) console.info('[INFO]', ...args); // eslint-disable-line no-console
  },
  warn: (...args) => {
    if (shouldLog('warn')) console.warn('[WARN]', ...args); // eslint-disable-line no-console
  },
  error: (...args) => {
    if (shouldLog('error')) console.error('[ERROR]', ...args); // eslint-disable-line no-console
  },
};

export default logger;
